import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouteReuseStrategy } from "@angular/router";
import { CustomRouteData } from "@modules/common/models/custom-route-data";
import { NEW_RECORD_PLACEHOLDER } from "@modules/routing/routes";

@Injectable({
    providedIn: 'root'
})
export class StingrayRouteReuseStrategy implements RouteReuseStrategy {
    shouldDetach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    store(route: ActivatedRouteSnapshot, handle: {} | null): void {
    }

    shouldAttach(route: ActivatedRouteSnapshot): boolean {
        return false;
    }

    retrieve(route: ActivatedRouteSnapshot): {} | null {
        return null;
    }

    shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        while (future.firstChild) {
            future = future.firstChild;
        }

        while (curr.firstChild) {
            curr = curr.firstChild;
        }

        if (this.routeReuseIsAllowed(future, curr)) {
            return true;
        }

        window.scroll(0, 0);
        return false;
    }

    private routeReuseIsAllowed(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
        //Check if the current and future routes are the same route config.
        if (!future.routeConfig?.data || !curr.routeConfig || future.routeConfig.data != curr.routeConfig.data) {
            return false;
        }
        //Check if this route config has special parameters that allow route reuse.
        const reuseParameterNames = (<CustomRouteData>future.routeConfig.data).allowRouteReuse;
        if (!reuseParameterNames) {
            return false;
        }
        //Route reuse is allowed if all of the special parameters match between the current and future routes.
        //Make an exception for the special value 'NEW-RECORD' in the current route; this will be treated as
        //always matching, so that navigating from a route with that value to a route with an actual value will
        //allow route reuse. The intended use case is updating the URL to contain a record's newly-generated id
        //after saving a new record.
        return reuseParameterNames.every(parameterName => curr.params[parameterName] == NEW_RECORD_PLACEHOLDER || future.params[parameterName] == curr.params[parameterName]);
    }
}
